import React, { useState } from "react";
import img from "../Assets/Spinner-3.gif";
import imageCompression from "browser-image-compression";

export const PccBgcForm = () => {
  const [isSameAddressChecked, setIsSameAddressChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(1);

  /* first form field */
  const [name, setName] = useState("");
  const [fname, setFname] = useState("");
  const [mname, setMname] = useState("");
  const [gender, setGender] = useState("");
  const [date, setDate] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [enumber, setEnumber] = useState("");
  const [companyname, setCompanyName] = useState("E T S TOURIST PRIVATE LIMITED");
  const [location, setLocation] = useState("");

  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [post, setPost] = useState("");
  const [police, setPolice] = useState("");
  const [district, setDistrict] = useState("");
  const [tehsil, setTehsil] = useState("");
  const [landmark, setLandmark] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");

  const [address11, setAddress11] = useState("");
  const [address22, setAddress22] = useState("");
  const [post1, setPost1] = useState("");
  const [police1, setPolice1] = useState("");
  const [district1, setDistrict1] = useState("");
  const [tehsil1, setTehsil1] = useState("");
  const [landmark1, setLandmark1] = useState("");
  const [pincode1, setPincode1] = useState("");
  const [state1, setState1] = useState("");

  /* second form field */
  const [reference_1_name, setReference_1_Name] = useState("");
  const [reference_1_relation, setReference_1_Relation] = useState("");
  const [reference_1_address, setReference_1_Address] = useState("");
  const [reference_1_number, setReference_1_Number] = useState("");
  const [reference_1_police_station, setReference_1_Police_Station] =
    useState("");

  const [reference_2_name, setReference_2_Name] = useState("");
  const [reference_2_relation, setReference_2_Relation] = useState("");
  const [reference_2_address, setReference_2_Address] = useState("");
  const [reference_2_number, setReference_2_Number] = useState("");
  const [reference_2_police_station, setReference_2_Police_Station] =
    useState("");

  const [errors, setErrors] = useState({});

  /* Third form field */
  const [aadhar, setAadhar] = useState("");
  const [aadhar_front_side, setAadhar_Front_Side] = useState("");
  const [aadhar_back_side, setAadhar_Back_Side] = useState("");
  const [passport_size_photo, setPassport_Size_Photo] = useState("");
  const [driving_license, setdriving_license] = useState("");
  const [candidate, setCandidateId] = useState("");

  const billingFunction = () => {
    setIsSameAddressChecked((prevValue) => !prevValue);
    if (isSameAddressChecked) {
      setAddress11("");
      setAddress22("");
      setPost1("");
      setPolice1("");
      setDistrict1("");
      setTehsil1("");
      setLandmark1("");
      setPincode1("");
      setState1("");
    } else {
      setAddress11(address1);
      setAddress22(address2);
      setPost1(post);
      setPolice1(police);
      setDistrict1(district);
      setTehsil1(tehsil);
      setLandmark1(landmark);
      setPincode1(pincode);
      setState1(state);
    }
  };

  const steps = ["Personal Details", "Witness", "Documents"];

  /*first page next......... */
  const validateStep1 = () => {
    const newErrors = {};

    // Required fields validation
    if (!name) newErrors.name = "Name of the Applicant is required";
    if (!fname) newErrors.fname = "Father's Name is required";
    if (!mname) newErrors.mname = "Mother's Name is required";

    if (!gender) newErrors.gender = "Gender is required";
    if (!date) newErrors.date = "Date of Birth is required";
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email format";
    }

    if (!number) {
      newErrors.number = "Contact Number is required";
    } else if (isNaN(number)) {
      newErrors.number = "Contact Number must be a number";
    }
    if (!enumber) {
      newErrors.enumber = "Emergency Contact is required";
    } else if (isNaN(enumber)) {
      newErrors.enumber = "Emergency Contact must be a number";
    }
    if (!location) newErrors.location = "Company Location is required";

    // Permanent Address validation
    if (!address1) newErrors.address1 = "Address Line 1 is required";
    if (!post) newErrors.post = "Post Office is required";
    if (!police) newErrors.police = "Police Station is required";
    if (!district) newErrors.district = "District is required";
    if (!pincode) {
      newErrors.pincode = "Pin Code is required";
    } else if (isNaN(pincode)) {
      newErrors.pincode = "Pin Code must be a number";
    }
    if (!tehsil) newErrors.tehsil = "Tehsil is required";
    if (!landmark) newErrors.landmark = "Landmark is required";
    if (!state) newErrors.state = "State is required";

    // Current Address validation
    if (!address11) newErrors.address11 = "Address Line 1 is required";
    if (!post1) newErrors.post1 = "Post Office is required";
    if (!police1) newErrors.police1 = "Police Station is required";
    if (!district1) newErrors.district1 = "District is required";
    if (!pincode1) {
      newErrors.pincode1 = "Pin Code is required";
    } else if (isNaN(pincode1)) {
      newErrors.pincode1 = "Pin Code must be a number";
    }
    if (!tehsil1) newErrors.tehsil1 = "Tehsil is required";
    if (!landmark1) newErrors.landmark1 = "Landmark is required";
    if (!state1) newErrors.state1 = "State is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep1 = () => {
    if (validateStep1()) {
      setStep((prevStep) => prevStep + 1);
    } else {
      alert("Please fill out all required fields");
    }
  };

  const nextStep2 = () => {
    const newErrors = {};

    if (!reference_1_name) newErrors.reference_1_name = "Name is required.";
    if (!reference_1_relation)
      newErrors.reference_1_relation = "Relation is required.";
    if (!reference_1_number) {
      newErrors.reference_1_number = "Contact number is required.";
    } else if (!/^\d{10}$/.test(reference_1_number)) {
      newErrors.reference_1_number = "Enter a valid 10-digit number.";
    }
    if (!reference_1_address)
      newErrors.reference_1_address = "Address is required.";
    if (!reference_1_police_station)
      newErrors.reference_1_police_station = "Police Station is required";

    if (!reference_2_name) newErrors.reference_2_name = "Name is required.";
    if (!reference_2_relation)
      newErrors.reference_2_relation = "Relation is required.";
    if (!reference_2_number) {
      newErrors.reference_2_number = "Contact number is required.";
    } else if (!/^\d{10}$/.test(reference_2_number)) {
      newErrors.reference_2_number = "Enter a valid 10-digit number.";
    }
    if (!reference_2_address)
      newErrors.reference_2_address = "Address is required.";
    if (!reference_2_police_station)
      newErrors.reference_2_police_station = "Police Station is required";

    const numbers = [reference_1_number, reference_2_number];
    const duplicateNumbers = numbers.filter(
      (number, index) => numbers.indexOf(number) !== index
    );

    if (duplicateNumbers.length > 0) {
      newErrors.duplicate = "Duplicate contact numbers are not allowed.";
      alert("Duplicate contact numbers are not allowed.");
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setStep((prevStep) => prevStep + 1);
    }
  };

  /*Fourth page next......... */
  const validateStep4 = () => {
    const newErrors = {};

    // Required fields validation
    if (!aadhar) {
      newErrors.aadhar = "Aadhar Number is required";
    } else if (!/^\d{12}$/.test(aadhar)) {
      newErrors.aadhar = "Aadhar must be exactly 12 digits";
    }
    if (!aadhar_front_side)
      newErrors.aadhar_front_side = "Aadhar Front Side is required";
    if (!aadhar_back_side)
      newErrors.aadhar_back_side = "Aadhar Back Side is required";
    if (!passport_size_photo)
      newErrors.passport_size_photo = "passport Size Photo is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /*Fourth page next......... */
  const nextStep4 = (e) => {
    e.preventDefault();
    if (validateStep4()) {
      BgcFormSubmit(e);
    } else {
      alert("Please fill out all required fields");
    }
  };

  const prevStep = () => {
    setStep((prevStep) => prevStep - 1);
  };

  /*Fifth form field...... */

  const handleFileChange = async (event, setStateFunction) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const options = {
          maxSizeMB: 0.5,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        setStateFunction(compressedFile);

        // console.log("Compressed file:", compressedFile);
      } catch (error) {
        console.error("Error compressing image:", error);
      }
    }
  };

  const BgcFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();
    formData.append("full_name", name);
    formData.append("fathers_name", fname);
    formData.append("mothers_name", mname);
    formData.append("gender", gender);
    formData.append("dob", date);
    formData.append("email", email);
    formData.append("contact_number", number);
    formData.append("emergency_number", enumber);
    formData.append("name_of_the_client", companyname);
    formData.append("client_location", location);

    formData.append("permanent_village_city", address1);
    formData.append("permanent_village_city2", address2);
    formData.append("permanent_post_office", post);
    formData.append("permanent_police_station", police);
    formData.append("permanent_district", district);
    formData.append("permanent_tehsil", tehsil);
    formData.append("permanent_landmark", landmark);
    formData.append("permanent_pincode", pincode);
    formData.append("permanent_state", state);

    formData.append("current_village_city", address11);
    formData.append("current_village_city2", address22);
    formData.append("current_post_office", post1);
    formData.append("current_police_station", police1);
    formData.append("current_district", district1);
    formData.append("current_tehsil", tehsil1);
    formData.append("current_landmark", landmark1);
    formData.append("current_pincode", pincode1);
    formData.append("current_state", state1);

    formData.append("ref_name1", reference_1_name);
    formData.append("ref_relation1", reference_1_relation);
    formData.append("ref_contact1", reference_1_number);
    formData.append("ref_address1", reference_1_address);
    formData.append("ref_police_station1", reference_1_police_station);
    formData.append("ref_name2", reference_2_name);
    formData.append("ref_relation2", reference_2_relation);
    formData.append("ref_contact2", reference_2_number);
    formData.append("ref_address2", reference_2_address);
    formData.append("ref_police_station2", reference_2_police_station);
    formData.append("adhar_number", aadhar);
    formData.append("adhar_frontside", aadhar_front_side);
    formData.append("adhar_backside", aadhar_back_side);
    formData.append("photo", passport_size_photo);
    formData.append("driving_license", driving_license);

    try {
      let response = await fetch(
        "https://humhai.in/background-verification/featured-form/",
        {
          method: "POST",
          body: formData,
        }
      );

      let data = await response.json();
      // console.log(data, "data");
      setCandidateId(data.id);
      console.log(data,"status")

      if (response.status === 200) {
        alert(
          `Your form has been successfully submitted. A reference ID will be provided once your data has been checked.`
        );
        window.location.reload();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      {/* Header Section */}
      <div className="form-header">
        {steps.map((heading, index) => (
          <div
            key={index}
            className={`step-title ${
              step === index + 1 ? "active" : "blurred"
            }`}
          >
            {heading}
          </div>
        ))}
      </div>

      {/* Form Content */}
      <div className="form-content">
        {/* First Form ...... */}
        {step === 1 && (
          <div className="bg-light p-3 rounded-lg border border-opacity-50 mx-auto p-1">
            <h2 className="text-center font-bold text-3xl mb-3">
              CANDIDATE{" "}
              <span className="text-orange-600">PERSONAL DETAILS</span>
            </h2>
            <hr />
            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="name_of_applicant" className="form-label">
                  Name of the Applicant
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.name ? "is-invalid" : ""
                  }`}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  name="name_of_applicant"
                  required
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input2" className="form-label">
                  Fathers/Husband/Wife Name
                </label>
                <input
                  className={`inputtype form-control mb-3 ${
                    errors.fname ? "is-invalid" : ""
                  }`}
                  list="projects"
                  value={fname}
                  onChange={(e) => setFname(e.target.value)}
                  name="fathers_name"
                  maxLength="100"
                  required
                />
                {errors.fname && (
                  <div className="invalid-feedback">{errors.fname}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input3" className="form-label">
                  Mother's Name
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.mname ? "is-invalid" : ""
                  }`}
                  value={mname}
                  onChange={(e) => setMname(e.target.value)}
                  name="mothers_name"
                  maxLength="100"
                  required
                />
                {errors.mname && (
                  <div className="invalid-feedback">{errors.mname}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input4" className="form-label">
                  Applicant Gender
                </label>{" "}
                <select
                  className={`inputtype form-control mb-3 ${
                    errors.gender ? "is-invalid" : ""
                  }`}
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  name="gender"
                >
                  <option value="">choose</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="other">other</option>
                </select>
                {errors.gender && (
                  <div className="invalid-feedback">{errors.gender}</div>
                )}
              </div>

              <div className="col-md-4 input-icons">
                <label htmlFor="Input5" className="form-label">
                  Date Of Birth
                </label>

                <div className="date-container">
                  <input
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    type="date"
                    className={`inputtype form-control mb-3 ${
                      errors.date ? "is-invalid" : ""
                    }`}
                    name="dob"
                    required
                  />
                  {errors.date && (
                    <div className="invalid-feedback">{errors.date}</div>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-6">
                <label htmlFor="Input6" className="form-label">
                  Email Id
                </label>{" "}
                <input
                  type="email"
                  className={`inputtype form-control mb-3 ${
                    errors.email ? "is-invalid" : ""
                  }`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  name="email"
                  required
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 input-icons">
                <label htmlFor="Input5" className="form-label">
                  Contact Number
                </label>

                <div className="date-container">
                  <input
                    type="number"
                    className={`inputtype form-control mb-3 ${
                      errors.number ? "is-invalid" : ""
                    }`}
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    name="contact_number"
                    required
                  />
                  {errors.number && (
                    <div className="invalid-feedback">{errors.number}</div>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-6">
                <label htmlFor="Input6" className="form-label">
                  Emergency Contact
                </label>

                <input
                  type="number"
                  className={`inputtype form-control mb-3 ${
                    errors.enumber ? "is-invalid" : ""
                  }`}
                  value={enumber}
                  onChange={(e) => setEnumber(e.target.value)}
                  name="emergency_contact"
                  required
                />
                {errors.enumber && (
                  <div className="invalid-feedback">{errors.enumber}</div>
                )}
              </div>

              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Company Name
                </label>

                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={companyname}
                  onChange={(e) => setCompanyName(e.target.value)}
                  name="name_of_client"
                  maxLength="100"
                  disabled
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Company Location
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.location ? "is-invalid" : ""
                  }`}
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  name="client_location"
                  maxLength="30"
                  required
                />
                {errors.location && (
                  <div className="invalid-feedback">{errors.location}</div>
                )}
              </div>
            </div>
            <div className="row">
              <h3 style={{ fontWeight: "500" }}>Permanent Address</h3>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Address Line 1
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.address1 ? "is-invalid" : ""
                  }`}
                  value={address1}
                  onChange={(e) => setAddress1(e.target.value)}
                  name="village_city"
                  maxLength="25"
                  required
                />
                {errors.address1 && (
                  <div className="invalid-feedback">{errors.address1}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Address Line 2 (Optional)
                </label>
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                  name="village_city2"
                  maxLength="25"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Name of Post Office
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.post ? "is-invalid" : ""
                  }`}
                  value={post}
                  onChange={(e) => setPost(e.target.value)}
                  name="post_office"
                  maxLength="100"
                  required
                />
                {errors.post && (
                  <div className="invalid-feedback">{errors.post}</div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Police Station/Thana
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.police ? "is-invalid" : ""
                  }`}
                  value={police}
                  onChange={(e) => setPolice(e.target.value)}
                  name="police_station"
                  maxLength="100"
                  required
                />
                {errors.police && (
                  <div className="invalid-feedback">{errors.police}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  District
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.district ? "is-invalid" : ""
                  }`}
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                  name="district"
                  maxLength="100"
                  required
                />
                {errors.district && (
                  <div className="invalid-feedback">{errors.district}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Tehsil
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.tehsil ? "is-invalid" : ""
                  }`}
                  value={tehsil}
                  onChange={(e) => setTehsil(e.target.value)}
                  name="tehsil"
                  maxLength="100"
                  required
                />
                {errors.tehsil && (
                  <div className="invalid-feedback">{errors.tehsil}</div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Landmark
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.landmark ? "is-invalid" : ""
                  }`}
                  value={landmark}
                  onChange={(e) => setLandmark(e.target.value)}
                  name="landmark"
                  maxLength="100"
                  required
                />
                {errors.landmark && (
                  <div className="invalid-feedback">{errors.landmark}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Pin Code
                </label>
                <input
                  type="number"
                  className={`inputtype form-control mb-3 ${
                    errors.pincode ? "is-invalid" : ""
                  }`}
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                  name="pine_code"
                  required
                />
                {errors.pincode && (
                  <div className="invalid-feedback">{errors.pincode}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  State
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.state ? "is-invalid" : ""
                  }`}
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  name="state"
                  maxLength="20"
                  required
                />
                {errors.state && (
                  <div className="invalid-feedback">{errors.state}</div>
                )}
              </div>
            </div>
            <div className="row mb-2 align-items-center">
              <div className="col-auto">
                <input
                  type="checkbox"
                  id="same"
                  className="form-check-input"
                  style={{ width: "20px", height: "20px" }}
                  onChange={() => billingFunction()}
                />
              </div>
              <div className="col-auto">
                <label htmlFor="same" className="form-check-label large" style={{fontWeight:'500'}}>
                  Same as above?
                </label>
              </div>
            </div>
            <div className="row">
              <h3 style={{ fontWeight: "500" }}>Current Address</h3>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Address Line 1
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.address11 ? "is-invalid" : ""
                  }`}
                  value={address11}
                  onChange={(e) => setAddress11(e.target.value)}
                  name="c_village_city"
                  maxLength="25"
                  required
                />
                {errors.address11 && (
                  <div className="invalid-feedback">{errors.address11}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Address Line 2 (Optional)
                </label>
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={address22}
                  onChange={(e) => setAddress22(e.target.value)}
                  name="c_village_city2"
                  maxLength="25"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Name of Post Office
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.post1 ? "is-invalid" : ""
                  }`}
                  value={post1}
                  onChange={(e) => setPost1(e.target.value)}
                  name="c_post_office"
                  maxLength="100"
                  required
                />
                {errors.post1 && (
                  <div className="invalid-feedback">{errors.post1}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Police Station/Thana
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.police1 ? "is-invalid" : ""
                  }`}
                  value={police1}
                  onChange={(e) => setPolice1(e.target.value)}
                  name="c_police_station"
                  maxLength="100"
                  required
                />
                {errors.police1 && (
                  <div className="invalid-feedback">{errors.police1}</div>
                )}
              </div>

              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  District
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.district1 ? "is-invalid" : ""
                  }`}
                  value={district1}
                  onChange={(e) => setDistrict1(e.target.value)}
                  name="c_district"
                  maxLength="100"
                  required
                />
                {errors.district1 && (
                  <div className="invalid-feedback">{errors.district1}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Tehsil
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.tehsil1 ? "is-invalid" : ""
                  }`}
                  value={tehsil1}
                  onChange={(e) => setTehsil1(e.target.value)}
                  name="c_tehsil"
                  maxLength="100"
                  required
                />
                {errors.tehsil1 && (
                  <div className="invalid-feedback">{errors.tehsil1}</div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Landmark
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.landmark1 ? "is-invalid" : ""
                  }`}
                  value={landmark1}
                  onChange={(e) => setLandmark1(e.target.value)}
                  name="c_landmark"
                  maxLength="100"
                  required
                />
                {errors.landmark1 && (
                  <div className="invalid-feedback">{errors.landmark1}</div>
                )}
              </div>

              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  Pin Code
                </label>
                <input
                  type="number"
                  className={`inputtype form-control mb-3 ${
                    errors.pincode1 ? "is-invalid" : ""
                  }`}
                  value={pincode1}
                  onChange={(e) => setPincode1(e.target.value)}
                  name="c_pine_code"
                  maxLength="100"
                  required
                />
                {errors.pincode1 && (
                  <div className="invalid-feedback">{errors.pincode1}</div>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input7" className="form-label">
                  State
                </label>
                <input
                  type="text"
                  className={`inputtype form-control mb-3 ${
                    errors.state1 ? "is-invalid" : ""
                  }`}
                  value={state1}
                  onChange={(e) => setState1(e.target.value)}
                  name="c_state"
                  maxLength="20"
                  required
                />
                {errors.state1 && (
                  <div className="invalid-feedback">{errors.state1}</div>
                )}
              </div>
            </div>

            <div style={{ overflow: "auto" }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  onClick={nextStep1}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Second Form ...... */}
        {step === 2 && (
          <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
            <div className="text-center font-bold text-3xl">
              🤝 CANDIDATE
              <span style={{ color: "rgb(255, 119, 0)" }}>
                {" "}
                Witness/Gavaah
              </span>{" "}
              DETAILS
            </div>
            <h5 className=" text-center" style={{ color: "rgb(255, 119, 0)" }}>
              * Duplicate contact numbers are not allowed. *
            </h5>
            <hr className="ms-5 me-5" />
            <div className="ref1 mb-4 text-center">
              <h4 style={{ color: "rgb(255, 119, 0)" }}>Add Witness 1</h4>
            </div>
            <hr className="ms-5 me-5 mb-4" />

            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input13" className="form-label">
                  Name
                </label>
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_1_name}
                  onChange={(e) => setReference_1_Name(e.target.value)}
                  name="ref_name1"
                  maxLength="100"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input14" className="form-label">
                  Relation
                </label>{" "}
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_1_relation}
                  onChange={(e) => setReference_1_Relation(e.target.value)}
                  name="ref_relation1"
                  maxLength="100"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input15" className="form-label">
                  Contact No.
                </label>
                <br />
                <input
                  type="number"
                  className="inputtype form-control mb-3"
                  value={reference_1_number}
                  onChange={(e) => setReference_1_Number(e.target.value)}
                  name="ref_conatact1"
                />
                {errors.reference_1_number && (
                  <div className="text-danger">{errors.reference_1_number}</div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input13" className="form-label">
                  Address
                </label>{" "}
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_1_address}
                  onChange={(e) => setReference_1_Address(e.target.value)}
                  name="ref_address1"
                  maxLength="100"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input13" className="form-label">
                  Police Station/Thana
                </label>{" "}
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_1_police_station}
                  onChange={(e) =>
                    setReference_1_Police_Station(e.target.value)
                  }
                  name="ref_address1"
                  maxLength="100"
                />
              </div>
            </div>

            <hr className="ms-5 me-5" />
            <div className="ref2 mb-4 text-center">
              <h4 style={{ color: "rgb(255, 119, 0)" }}>Add Witness 2</h4>
            </div>
            <hr className="ms-5 me-5 mb-4" />
            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input13" className="form-label">
                  Name
                </label>{" "}
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_2_name}
                  onChange={(e) => setReference_2_Name(e.target.value)}
                  name="ref_name2"
                  maxLength="100"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input14" className="form-label">
                  Relation
                </label>{" "}
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_2_relation}
                  onChange={(e) => setReference_2_Relation(e.target.value)}
                  name="ref_relation2"
                  maxLength="100"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input15" className="form-label">
                  Contact No.
                </label>
                <br />
                <input
                  type="number"
                  className="inputtype form-control mb-3"
                  value={reference_2_number}
                  onChange={(e) => setReference_2_Number(e.target.value)}
                  name="ref_contact2"
                />
                {errors.reference_2_number && (
                  <div className="text-danger">{errors.reference_2_number}</div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-6">
                <label htmlFor="Input13" className="form-label">
                  Address
                </label>{" "}
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_2_address}
                  onChange={(e) => setReference_2_Address(e.target.value)}
                  name="ref_address2"
                  maxLength="100"
                />
              </div>
              <div className="col-md-4 col-6">
                <label htmlFor="Input13" className="form-label">
                  Police Station/Thana
                </label>{" "}
                <br />
                <input
                  type="text"
                  className="inputtype form-control mb-3"
                  value={reference_2_police_station}
                  onChange={(e) =>
                    setReference_2_Police_Station(e.target.value)
                  }
                  name="ref_address1"
                  maxLength="100"
                />
              </div>
            </div>

            <div style={{ overflow: "auto" }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  style={{ backgroundColor: "#BBBBBB" }}
                  onClick={prevStep}
                >
                  Previous
                </button>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  onClick={nextStep2}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Third Form ...... */}
        {step === 3 && (
          <div>
            <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
              <div className="text-center font-bold text-3xl">
                📄 CANDIDATE
                <span style={{ color: "rgb(255, 119, 0)" }}>
                  {" "}
                  DOCUMENTS{" "}
                </span>{" "}
                DETAILS
              </div>
              <h5
                className=" text-center"
                style={{ color: "rgb(255, 119, 0)" }}
              >
                * Upload a Fully Clear and Completed Document *
              </h5>
              <h4 style={{ color: "red", textAlign: "center" }}>
                * use .jpg and .png format *{" "}
              </h4>
              <hr />
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="Input7" className="form-label">
                    Aadhar Card Number
                  </label>
                  <input
                    type="text"
                    value={aadhar}
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 12);
                      setAadhar(value);
                      if (errors.aadhar && value.length === 12) {
                        setErrors({ ...errors, aadhar: "" });
                      }
                    }}
                    name="aadhar_card"
                    className={`inputtype form-control mb-3 ${
                      errors.aadhar ? "is-invalid" : ""
                    }`}
                    inputMode="numeric"
                    pattern="\d{12}"
                    maxLength="12"
                    placeholder="Enter 12-digit Aadhar number"
                    required
                  />
                  {errors.aadhar && (
                    <div className="invalid-feedback">
                      {errors.aadhar === "Aadhar Number is required"
                        ? "Aadhar Number is required"
                        : "Aadhar must be exactly 12 digits (numbers only)"}
                    </div>
                  )}
                </div>
                <div className="col-md-4">
                  <label htmlFor="Input8" className="form-label">
                    Aadhar Card FRONT SIDE
                  </label>
                  <input
                    type="file"
                    onChange={(e) => handleFileChange(e, setAadhar_Front_Side)}
                    accept=".png, .jpg"
                    name="aadhar_front"
                    className={`inputtype form-control mb-3 ${
                      errors.aadhar_front_side ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.aadhar_front_side && (
                    <div className="invalid-feedback">
                      {errors.aadhar_front_side}
                    </div>
                  )}
                </div>
                <div className="col-md-4">
                  <label htmlFor="Input9" className="form-label">
                    Aadhar Card BACK SIDE
                  </label>
                  <input
                    type="file"
                    onChange={(e) => handleFileChange(e, setAadhar_Back_Side)}
                    name="aadhar_back"
                    accept=".png, .jpg"
                    className={`inputtype form-control mb-3 ${
                      errors.aadhar_back_side ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.aadhar_back_side && (
                    <div className="invalid-feedback">
                      {errors.aadhar_back_side}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="Input9" className="form-label">
                    Passport Size Photo
                  </label>
                  <input
                    type="file"
                    onChange={(e) =>
                      handleFileChange(e, setPassport_Size_Photo)
                    }
                    name="passport_photo"
                    accept=".png, .jpg"
                    className={`inputtype form-control mb-3 ${
                      errors.passport_size_photo ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.passport_size_photo && (
                    <div className="invalid-feedback">
                      {errors.passport_size_photo}
                    </div>
                  )}
                </div>
                <div className="col-md-4">
                  <label htmlFor="Input9" className="form-label">
                    Driver Licence
                  </label>
                  <input
                    type="file"
                    className="inputtype form-control mb-3"
                    onChange={(e) => handleFileChange(e, setdriving_license)}
                    name="driving_license"
                    accept=".png, .jpg"
                  />
                </div>
              </div>
              <div className="row ms-4 mb-4">
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: "1",
                      flexDirection: "column",
                    }}
                  >
                    {" "}
                    <img src={img} alt="" />
                    <div
                      style={{
                        color: "#DE3500",
                        marginTop: "10px",
                      }}
                    >
                      Please Wait ......
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div style={{ overflow: "auto" }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  style={{ backgroundColor: "#BBBBBB" }}
                  onClick={prevStep}
                  disabled={isLoading}
                >
                  Previous
                </button>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  onClick={nextStep4}
                  disabled={isLoading}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
